<template>
  <div class="AllBox">
    <myNav title="编辑昵称" @clickRight="onQuit"></myNav>

    <div class="mainBox">
      <p>昵称修改后,仅在此群内显示,群内成员都可以看见</p>
      <van-field
        class="inputField"
        clearable
        center
        :placeholder="state.name"
        v-model="state.inputText"
        maxlength="10"
        @clear="clearInput"
      ></van-field>

      <div
        :class="nickOK() == true ? 'bottomV' : 'bottomVGray'"
        @click="onQuit"
      >
        <span>保存</span>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast } from "vant";
import SDK from "@yxim/nim-web-sdk";
import router from "@/router";
import { useStore } from "vuex";
import nav from "@/components/nav01.vue";

export default {
  name: "GroupName",
  components: {
    myNav: nav,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      teamData: {},
      nim: null,
      name: "",
      uid: store.state.id,
      teamId: "12553569744",
      // teamId: route.query.teamId,
      inputText: "",
      myMap: new Map(), //创建map对象
      dataInfo: {
        myInfo: {},
        users: [],
        teamMembers: [],
        teams: [],
      },
    });

    //判断
    const nickOK = () => {
      if (state.name != state.inputText && state.inputText.length > 1) {
        return true;
      } else {
        return false;
      }
    };
    // 返回
    const onClickLeft = () => {
      router.back();
    };
    //解散或退群
    const onQuit = () => {
      if (nickOK() == false) {
        Toast("请输入昵称");
        return;
      }
      state.nim.updateInfoInTeam({
        teamId: state.teamId,
        // 此参数为可选参数
        nickInTeam: state.inputText,
        // 静音群, 此参数为可选参数
        // muteTeam: true,
        // muteNotiType: 1,
        // 第三方扩展字段
        // custom: '{}'
        done: updateInfoInTeamDone,
      });
    };
    const updateInfoInTeamDone = (error, obj) => {
      // console.log(error);
      // console.log(obj);
      // console.log("修改自己的群属性" + (!error ? "成功" : "失败"));
      if (!error) {
        router.go(-1);
      }
    };
    onMounted(() => {
      // console.log("mounted初始化uid -----------------------------------", state.uid);
      window.scrollTo(0, 0);
      console.log("mounted");
      state.name = route.query.name;
      state.teamId = route.query.teamId;
      //初始化IM
      // this.nim = SDK.NIM.getInstance();
      state.nim = SDK.NIM.getInstance({
        // 初始化SDK
        debug: true,
        appKey: store.state.appKey,
        account: store.state.wyAccount,
        token: store.state.wyToken,
        debugLevel: "debug",
        db: false,
      });
    });

    const clearInput = () => {
      // console.log('点击了清空按钮-+-+-+-+-+-+-+-')
    };

    return {
      state,
      nickOK,
      onClickLeft,
      onQuit,
      updateInfoInTeamDone,
      clearInput,
    };
  },
};
</script>

<style scoped="scoped">
.mainBox {
  /* height: 2000px; */
  height: 100vh;
  background-color: #161b1f;
  padding: 32px;
  padding-top: calc(132px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(132px + env(safe-area-inset-top));
  overflow: auto;
}

.mainBox p {
  font-size: 24px;
  color: #fff;
  margin-top: 24px;
  margin-bottom: 22px;
}

.van-cell {
  /* display: block; */
  display: flex;
}
.inputField {
  height: 88px;
  border-radius: 8px;
  background-color: #283138;
  padding: 30px 28px;
  color: #303133;
}
.van-field__body {
  height: 100%;
}
::v-deep .van-field__control {
  color: #fff;
}
.van-cell::after {
  border: none;
}

.bottomV {
  /* position: fixed;
  bottom: 100px; */
  text-align: center;
  background-color: #12cec7;
  color: #fff;
  width: 680px;
  height: 72px;
  margin: 64px auto;
  border-radius: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottomVGray {
  /* position: fixed;
  bottom: 100px; */
  text-align: center;
  background-color: #ccc;
  color: #fff;
  width: 680px;
  height: 72px;
  margin: 64px auto;
  border-radius: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
